import { createSlice } from "@reduxjs/toolkit";
import {fetchPaymentPlans} from "../../services";

const paymentplanSlice = createSlice({
  name: "paymentplan",
  initialState: {
    error: false,
    loading: false,
    data: null,
    lastUpdated: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentPlans.pending, (state) => {
        state.error = false;
        state.loading = true;
        state.data = null;
      })
      .addCase(fetchPaymentPlans.fulfilled, (state, action) => {
        state.data = action.payload.plans;
        state.loading = false;
        state.error = false;
        state.lastUpdated = new Date().toISOString();
      })
      .addCase(fetchPaymentPlans.rejected, (state, action) => {
        state.data = null;
        state.error = action.payload || true;
        state.loading = false;
      });
  },
});

export const { } = paymentplanSlice.actions;
export default paymentplanSlice.reducer;